export enum EnvKeys {
  BACKEND_PATH = 'backend-path',
  EMAIL_SERVICE_HOST = 'email-service-host',
  RECAPTCHA_SITEKEY = 'raecapcha-sitekey',
  FEATURE_IS_LEAD_FORM = 'feature-is-lead-form',
}
